// import React, { useState } from "react";

// const API_URL = "https://api.securxperts.com:8000/receipts/generate";

// const EnrollmentReceiptForm = () => {
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const [error, setError] = useState("");

//   const [form, setForm] = useState({
//     student_name: "",
//     student_email: "",
//     student_mobile: "",
//     referred_by: "",
//     amount_paid: "",
//     remaining_balance: "",
//     reminder_date: "",
//     course_name: "",
//     course_model: "",
//     course_amount: "",
//     payment_mode: "",
//     utr_number: "",
//     recipients: "",
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setMessage("");
//     setLoading(true);

//     const token = localStorage.getItem("access_token");

//     if (!token) {
//       setError("Unauthorized. Please login again.");
//       setLoading(false);
//       return;
//     }

//     const payload = {
//       student_name: form.student_name,
//       student_email: form.student_email,
//       student_mobile: form.student_mobile,
//       referred_by: form.referred_by,
//       amount_paid: Number(form.amount_paid),
//       remaining_balance: Number(form.remaining_balance),
//       reminder_date: form.reminder_date,
//       courses: [
//         {
//           name: form.course_name,
//           model: form.course_model,
//           amount: Number(form.course_amount),
//           payment_mode: form.payment_mode,
//           date: null,
//           utr_number: form.utr_number,
//         },
//       ],
//       recipients: form.recipients
//         .split(",")
//         .map((email) => email.trim()),
//     };

//     try {
//       const res = await fetch(API_URL, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();

//       if (!res.ok) {
//         throw new Error(data.detail || "Receipt generation failed");
//       }

//       setMessage("Receipt generated and email sent successfully.");
//       setForm({
//         student_name: "",
//         student_email: "",
//         student_mobile: "",
//         referred_by: "",
//         amount_paid: "",
//         remaining_balance: "",
//         reminder_date: "",
//         course_name: "",
//         course_model: "",
//         course_amount: "",
//         payment_mode: "",
//         utr_number: "",
//         recipients: "",
//       });
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="max-w-3xl mx-auto bg-white p-8 rounded-2xl shadow-lg">
//       <h2 className="text-2xl font-bold mb-6 text-center">
//         Enrollment Receipt Form
//       </h2>

//       {error && <p className="text-red-600 mb-4 text-center">{error}</p>}
//       {message && <p className="text-green-600 mb-4 text-center">{message}</p>}

//       <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <input name="student_name" placeholder="Student Name" value={form.student_name} onChange={handleChange} required className="input" />
//         <input name="student_email" type="email" placeholder="Student Email" value={form.student_email} onChange={handleChange} required className="input" />
//         <input name="student_mobile" placeholder="Mobile Number" value={form.student_mobile} onChange={handleChange} required className="input" />
//         <input name="referred_by" placeholder="Referred By" value={form.referred_by} onChange={handleChange} className="input" />

//         <input name="amount_paid" type="number" placeholder="Amount Paid" value={form.amount_paid} onChange={handleChange} required className="input" />
//         <input name="remaining_balance" type="number" placeholder="Remaining Balance" value={form.remaining_balance} onChange={handleChange} required className="input" />
//         <input name="reminder_date" type="date" value={form.reminder_date} onChange={handleChange} required className="input" />

//         <input name="course_name" placeholder="Course Name" value={form.course_name} onChange={handleChange} required className="input" />
//         <input name="course_model" placeholder="Course Model" value={form.course_model} onChange={handleChange} required className="input" />
//         <input name="course_amount" type="number" placeholder="Course Amount" value={form.course_amount} onChange={handleChange} required className="input" />
//         <input name="payment_mode" placeholder="Payment Mode" value={form.payment_mode} onChange={handleChange} required className="input" />
//         <input name="utr_number" placeholder="UTR Number" value={form.utr_number} onChange={handleChange} required className="input" />

//         <input
//           name="recipients"
//           placeholder="Recipient Emails (comma separated)"
//           value={form.recipients}
//           onChange={handleChange}
//           required
//           className="input md:col-span-2"
//         />

//         <button
//           type="submit"
//           disabled={loading}
//           className="md:col-span-2 bg-indigo-600 text-white py-3 rounded-xl hover:bg-indigo-700 transition"
//         >
//           {loading ? "Generating..." : "Generate & Send Receipt"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default EnrollmentReceiptForm;




import React, { useState } from "react";

const EnrollmentReceiptForm = () => {
  const [form, setForm] = useState({
    student_name: "",
    student_email: "",
    student_mobile: "",
    referred_by: "",
    amount_paid: "",
    remaining_balance: "",
    reminder_date: "",
    course_name: "",
    model: "",
    course_amount: "",
    payment_mode: "",
    utr_number: "",
    recipient_email: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    const token = localStorage.getItem("access_token") || sessionStorage.getItem("access_token");

    const payload = {
      student_name: form.student_name,
      student_email: form.student_email,
      student_mobile: form.student_mobile,
      referred_by: form.referred_by,
      amount_paid: Number(form.amount_paid),
      remaining_balance: Number(form.remaining_balance),
      reminder_date: form.reminder_date,
      courses: [
        {
          name: form.course_name,
          model: form.model,
          amount: Number(form.course_amount),
          payment_mode: form.payment_mode,
          date: null,
          utr_number: form.utr_number,
        },
      ],
      recipients: [form.recipient_email],
    };

    try {
      const res = await fetch(
        "https://api.securxperts.com:8000/receipts/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Failed to generate receipt");
      }

      setMessage({ type: "success", text: "Receipt generated & email Sent Successfully." });

      setForm({
        student_name: "",
        student_email: "",
        student_mobile: "",
        referred_by: "",
        amount_paid: "",
        remaining_balance: "",
        reminder_date: "",
        course_name: "",
        model: "",
        course_amount: "",
        payment_mode: "",
        utr_number: "",
        recipient_email: "",
      });
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 flex items-center justify-center px-4">
      <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl p-8">
        <h2 className="text-3xl font-bold text-center text-indigo-700 mb-2">
          Enrollment Receipt
        </h2>
        <p className="text-center text-gray-500 mb-8">
          Generate & email student payment receipt
        </p>

        {message && (
          <div
            className={`mb-6 p-4 rounded-xl text-center font-medium ${
              message.type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Student Details */}
          <input className="input" name="student_name" placeholder="Student Name" value={form.student_name} onChange={handleChange} required />
          <input className="input" name="student_email" placeholder="Student Email" value={form.student_email} onChange={handleChange} required />
          <input className="input" name="student_mobile" placeholder="Student Mobile" value={form.student_mobile} onChange={handleChange} required />
          <input className="input" name="referred_by" placeholder="Referred By" value={form.referred_by} onChange={handleChange} />

          {/* Payment */}
          <input className="input" type="number" name="amount_paid" placeholder="Amount Paid" value={form.amount_paid} onChange={handleChange} required />
          <input className="input" type="number" name="remaining_balance" placeholder="Remaining Balance" value={form.remaining_balance} onChange={handleChange} />
          <input className="input" type="date" name="reminder_date" value={form.reminder_date} onChange={handleChange} />

          {/* Course */}
          <input className="input" name="course_name" placeholder="Course Name" value={form.course_name} onChange={handleChange} required />
          <input className="input" name="model" placeholder="Course Model" value={form.model} onChange={handleChange} />
          <input className="input" type="number" name="course_amount" placeholder="Course Amount" value={form.course_amount} onChange={handleChange} required />
          <input className="input" name="payment_mode" placeholder="Payment Mode" value={form.payment_mode} onChange={handleChange} required />
          <input className="input" name="utr_number" placeholder="UTR Number" value={form.utr_number} onChange={handleChange} />

          {/* Email */}
          <input
            className="input md:col-span-2"
            name="recipient_email"
            placeholder="Recipient Email"
            value={form.recipient_email}
            onChange={handleChange}
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="md:col-span-2 mt-4 py-3 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700 transition disabled:opacity-60"
          >
            {loading ? "Generating..." : "Generate & Send Receipt"}
          </button>
        </form>
      </div>

      {/* Tailwind input helper */}
      <style>{`
        .input {
          width: 100%;
          padding: 12px 14px;
          border-radius: 12px;
          border: 1px solid #d1d5db;
          outline: none;
        }
        .input:focus {
          border-color: #6366f1;
          box-shadow: 0 0 0 2px rgba(99,102,241,0.15);
        }
      `}</style>
    </div>
  );
};

export default EnrollmentReceiptForm;













// import React, { useState, useEffect } from 'react';

// const EnrollmentReceiptForm = () => {
//   const [formData, setFormData] = useState({
//     userName: '',
//     userEmail: '',
//     userMobile: '',
//     courseName: '',
//     courseModel: '1.0',
//     courseFee: '',
//     feePaid: '',
//     remainingBalance: '',
//     paymentMode: 'Cash',
//     utrNumber: '',
//     referredBy: '',
//     reminderDate: ''
//   });
//   const [referrals, setReferrals] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   useEffect(() => {
//     fetchReferrals();
//   }, []);

//   const fetchReferrals = async () => {
//     try {
//       const response = await fetch('data.json');
//       const data = await response.json();
//       setReferrals(data.referrals || []);
//     } catch (err) {
//       console.error('Error fetching referral data:', err);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//     setError('');

//     if (name === 'courseFee' || name === 'feePaid') {
//       calculateRemainingBalance(value, name === 'courseFee' ? formData.feePaid : e.target.value);
//     }
//   };

//   const calculateRemainingBalance = (courseFeeVal, feePaidVal) => {
//     const totalFee = parseFloat(courseFeeVal) || 0;
//     const paidAmount = parseFloat(feePaidVal) || 0;
//     const remaining = totalFee - paidAmount;
//     setFormData(prev => ({
//       ...prev,
//       remainingBalance: `₹${remaining.toFixed(2)}`,
//       reminderDate: remaining <= 0 ? "0-0-0000" : new Date(Date.now() + 30 * 86400000).toISOString().split('T')[0]
//     }));
//   };

//   const handlePaymentModeChange = (e) => {
//     const value = e.target.value;
//     setFormData(prev => ({ ...prev, paymentMode: value, utrNumber: value.toLowerCase() === 'cash' ? '' : prev.utrNumber }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     const mode = formData.paymentMode;
//     const isCash = mode.toLowerCase() === 'cash';
//     const courseUTR = isCash ? null : formData.utrNumber.trim();

//     const receiptData = {
//       student_name: formData.userName,
//       student_email: formData.userEmail,
//       student_mobile: formData.userMobile,
//       referred_by: formData.referredBy,
//       amount_paid: parseFloat(formData.feePaid),
//       remaining_balance: parseFloat(formData.remainingBalance.replace('₹', '')),
//       reminder_date: formData.reminderDate,
//       courses: [{
//         name: formData.courseName,
//         model: formData.courseModel,
//         amount: parseFloat(formData.courseFee),
//         payment_mode: mode,
//         date: new Date().toISOString().split('T')[0],
//         utr_number: courseUTR
//       }],
//       recipients: [formData.userEmail]
//     };

//     try {
//       // Get access token from session storage
//       const accessToken = sessionStorage.getItem("access_token");
//       const tokenType = sessionStorage.getItem("token_type") || "bearer";

//       if (!accessToken) {
//         setError("You must be logged in to generate receipts.");
//         setLoading(false);
//         return;
//       }

//       // Build headers with authentication
//       const headers = {
//         'Content-Type': 'application/json',
//         'Authorization': `${tokenType} ${accessToken}`
//       };

//       console.log('📤 Sending receipt generation request:', {
//         url: "https://api.securxperts.com:8000/receipts/generate",
//         payload: receiptData
//       });

//       const response = await fetch('https://api.securxperts.com:8000/receipts/generate', {
//         method: 'POST',
//         headers: headers,
//         body: JSON.stringify(receiptData)
//       });

//       console.log('📥 Receipt generation response status:', response.status, response.statusText);

//       let result;
//       try {
//         result = await response.json();
//         console.log('📥 Receipt generation response data:', result);
//       } catch (parseError) {
//         const text = await response.text();
//         console.error('❌ Receipt API Response (non-JSON):', text);
//         throw new Error("Server returned an invalid response. Please try again.");
//       }

//       if (response.ok) {
//         // API response format: { message, receipt_no, pdf_s3_key, pdf_url, email_error }
//         console.log('✅ Receipt generated successfully!', {
//           receipt_no: result.receipt_no,
//           pdf_url: result.pdf_url,
//           message: result.message,
//           email_error: result.email_error
//         });
        
//         let successMsg = result.message || 'Receipt sent successfully!';
//         if (result.receipt_no) {
//           successMsg += `\nReceipt No: ${result.receipt_no}`;
//         }
//         if (result.email_error) {
//           successMsg += `\nNote: ${result.email_error}`;
//         }
        
//         alert(successMsg);
        
//         // Optionally reset form after successful submission
//         // You can uncomment this if you want to clear the form:
//         // setFormData({
//         //   userName: '', userEmail: '', userMobile: '', courseName: '',
//         //   courseModel: '1.0', courseFee: '', feePaid: '', remainingBalance: '',
//         //   paymentMode: 'Cash', utrNumber: '', referredBy: '', reminderDate: ''
//         // });
//       } else {
//         // Handle errors
//         let errorMsg = "Failed to generate receipt.";
        
//         if (result.detail) {
//           if (Array.isArray(result.detail)) {
//             errorMsg = result.detail.map(d => d.msg || d).join(', ');
//           } else if (typeof result.detail === 'string') {
//             errorMsg = result.detail;
//           }
//         } else if (result.message) {
//           errorMsg = result.message;
//         } else if (result.error) {
//           errorMsg = result.error;
//         }

//         console.error('❌ Receipt generation failed:', {
//           status: response.status,
//           error: errorMsg,
//           fullResponse: result
//         });
        
//         throw new Error(errorMsg);
//       }
//     } catch (err) {
//       console.error('❌ Error:\n', err.message);
//       setError(err.message);
//       alert("❌ Failed:\n" + err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ 
//       background: 'linear-gradient(135deg, #8eb3eb, #6be3e7)', 
//       minHeight: '100vh', 
//       padding: '20px' 
//     }}>
//       <style jsx global>{`
//         .container {
//           background: white;
//           border-radius: 15px;
//           box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
//           padding: 30px;
//         }
//         h1 {
//           color: #205e9c;
//           font-weight: bold;
//         }
//         .form-control, .form-select {
//           border-radius: 10px;
//         }
//         .btn-primary {
//           background: linear-gradient(135deg, #3498db, #2980b9);
//           border-radius: 10px;
//         }
//         .error-message {
//           color: red;
//           text-align: center;
//           margin-top: 1rem;
//         }
//       `}</style>

//       <div className="container mt-5">
//         <h1 className="text-center mb-4 bg-light">Enrollment Receipt</h1>
//         <form onSubmit={handleSubmit}>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="userName">Student Name</label>
//             <input
//               className="form-control"
//               id="userName"
//               name="userName"
//               type="text"
//               value={formData.userName}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="userEmail">Student Email</label>
//             <input
//               className="form-control"
//               id="userEmail"
//               name="userEmail"
//               type="email"
//               value={formData.userEmail}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="userMobile">Student Mobile</label>
//             <input
//               className="form-control"
//               id="userMobile"
//               name="userMobile"
//               type="tel"
//               value={formData.userMobile}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="courseName">Enter Course Name</label>
//             <input
//               className="form-control"
//               id="courseName"
//               name="courseName"
//               placeholder="Enter course name"
//               type="text"
//               value={formData.courseName}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="courseModel">Course Model</label>
//             <select
//               className="form-select"
//               id="courseModel"
//               name="courseModel"
//               value={formData.courseModel}
//               onChange={handleChange}
//               required
//             >
//               <option value="1.0">1.0</option>
//               <option value="2.0">2.0</option>
//               <option value="3.0">3.0</option>
//             </select>
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="courseFee">Enter Course Fee</label>
//             <input
//               className="form-control"
//               id="courseFee"
//               name="courseFee"
//               placeholder="Enter course fee"
//               type="number"
//               value={formData.courseFee}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="feePaid">Fee Paid</label>
//             <input
//               className="form-control"
//               id="feePaid"
//               name="feePaid"
//               type="number"
//               value={formData.feePaid}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="remainingBalance">Remaining Balance</label>
//             <input
//               className="form-control"
//               id="remainingBalance"
//               type="text"
//               value={formData.remainingBalance}
//               readOnly
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="paymentMode">Payment Mode</label>
//             <select
//               className="form-select"
//               id="paymentMode"
//               name="paymentMode"
//               value={formData.paymentMode}
//               onChange={handlePaymentModeChange}
//               required
//             >
//               <option value="Cash">Cash</option>
//               <option value="Credit Card">Credit Card</option>
//               <option value="Phone Pay">Phone Pay</option>
//               <option value="Google Pay">Google Pay</option>
//               <option value="Bank Transfer">Bank Transfer</option>
//             </select>
//           </div>
//           <div className="mb-3" style={{ display: formData.paymentMode.toLowerCase() === 'cash' ? 'none' : 'block' }} id="utrSection">
//             <label className="form-label" htmlFor="utrNumber">UTR Number</label>
//             <input
//               className="form-control"
//               id="utrNumber"
//               name="utrNumber"
//               placeholder="Enter UTR number"
//               type="text"
//               value={formData.utrNumber}
//               onChange={handleChange}
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="referredBy">Referred By</label>
//             <select
//               className="form-select"
//               id="referredBy"
//               name="referredBy"
//               value={formData.referredBy}
//               onChange={handleChange}
//               required
//             >
//               <option value="">Select a name</option>
//               {referrals.map((referral) => (
//                 <option key={referral.name} value={referral.name}>
//                   {referral.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="mb-3">
//             <label className="form-label" htmlFor="reminderDate">Reminder Date</label>
//             <input
//               className="form-control"
//               id="reminderDate"
//               type="text"
//               value={formData.reminderDate}
//               readOnly
//             />
//           </div>
//           <button className="btn btn-primary w-100" type="submit" disabled={loading}>
//             {loading ? 'Sending...' : 'Send Receipt'}
//           </button>
//           {error && <p className="error-message">{error}</p>}
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EnrollmentReceiptForm;